
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ActivityCategoryForm } from "./ActivityCategoryForm";
import { Tables } from "@/integrations/supabase/types";

type ActivityCategory = Tables<"activity_categories">;

interface ActivityCategoryEditDialogProps {
  category: ActivityCategory | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (category: any) => void;
}

export const ActivityCategoryEditDialog = ({ 
  category, 
  open, 
  onOpenChange, 
  onSave 
}: ActivityCategoryEditDialogProps) => {
  const handleSave = (categoryData: any) => {
    onSave(categoryData);
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {category ? "Edit Activity Category" : "Create New Activity Category"}
          </DialogTitle>
        </DialogHeader>
        <ActivityCategoryForm
          category={category || undefined}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
};
